import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DateTime } from 'luxon';
import { PROFILE_COMPONENTS_COMMON_LOCALIZATION_SCOPE } from '../../models/constants';

@Component({
  selector: 'ca-excluded-from-mail',
  templateUrl: './excluded-from-mail.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExcludedFromMailComponent {
  localizationScope = PROFILE_COMPONENTS_COMMON_LOCALIZATION_SCOPE;
  lastModifiedDate: string = '';

  @Input() excludedBy?: string;
  @Input() excludedFromMailUserId?: number;
  @Input() set excludedFromMailLastModified(value: string | undefined) {
    this.lastModifiedDate = this.convertDate(value);
  }

  private convertDate(value?: string) {
    if (!value) return '';
    const date = new Date(value);

    return DateTime.utc(
      date.getFullYear(),
      date.getMonth() + 1,
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds()
    ).toString();
  }
}
